import api from "../services/api";
import handleError from "./errorHandler";
import { formatResponse } from "./objectUtils";

/**
 * Função global para realizar requisições à API.
 *
 * @param {string} method - Método HTTP (get, post, put, delete).
 * @param {string} url - Endpoint da API.
 * @param {object} [data={}] - Dados ou parâmetros para a requisição.
 * @param {function|null} [navigate=null] - Função para redirecionamento em caso de erro.
 * @param {object} [options={}] - Configuração Axios para a requisição.
 * @returns {Promise<object>} - Resposta formatada da API ou erro tratado.
 */
export default async function request(method, url, data = {}, navigate = null, options = {}) {
  try {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const headers = !isFormData && data && typeof data === "object" ? data.headers : undefined;
    const payload = headers ? { ...data } : data;
    if (headers) delete payload.headers;

    const config = method === "get"
      ? { params: payload, headers: { ...headers } }
      : { ...options, ...(headers ? { headers: { ...headers, ...options.headers } } : {}) };
    const response = method === "get" || method === "delete"
      ? await api[method](url, method === "delete" ? { ...payload, ...config } : config)
      : await api[method](url, payload, config);

    return formatResponse(response.data.message, response.status, response.data.result);
  } catch (error) {
    return handleError(error, navigate);
  }
}
